import React from 'react';
import withSizes from 'react-sizes';
import { Link } from 'react-router-dom'
import { Capacitor } from '@capacitor/core';

import SignInButton from './SignInButton'
import FooterIOS from './FooterIOS'
import AppleSignInButton from './buttons/AppleSignInButton'
import CWIcon from './icons/CWIcon'

function UvpMobile(props) {
  return (
		<div className="native-uvp-mobile">
			<main className="native-uvp-mobile-content">
				<Link className="no-link native-uvp-mobile-brand" to="/">
					<CWIcon theme='light' size={40}/>
					<span className="native-uvp-mobile-brand-text">
						<span style={{fontWeight: 300}}>Crypto</span><b>Waves</b>
					</span>
				</Link>
				{props.isBlogPost &&
					<span className='small mt-2'>
						<a href="/">« Back To App</a>
					</span>
				}

				<div className="native-uvp-mobile-copy">
					<div className="native-uvp-mobile-eyebrow">RSI Crypto Heatmap</div>
					<h1 className="native-uvp-mobile-title">
						Crypto Market RSI Scanner And Tracker
					</h1>
					{/*<p className="native-uvp-mobile-subtitle">
						Real-time Crypto Market RSI Heatmap and Alerts on Mobile, Email, and Telegram.
					</p>*/}
				</div>

				<div className="native-uvp-mobile-actions">
				<div className='ios-button native-uvp-mobile-signin'>
					<SignInButton iconSize={20} showDescription={false}>
						Sign in with Google
					</SignInButton>
				</div>

				{Capacitor.getPlatform() === 'ios' &&
					<div className="native-uvp-mobile-apple">
						<AppleSignInButton>
						</AppleSignInButton>
					</div>
				}
				</div>
			</main>
			<FooterIOS></FooterIOS>
		</div>
	);
};

UvpMobile.defaultProps = {
  showLogInButton: true,
  ios: false,
  showScreenshots: true,
  showNav: false,
  showScrollTo: true,
  fullScreen: 'vh-100',
  h1: false,
	isBlogPost: false
};

const mapSizesToProps = ({ width }) => ({
  isMobile: width < 480,
  isDesktop: width >= 1024
})

export default withSizes(mapSizesToProps)(UvpMobile);
